export default class Slider {

    constructor(opts) {
        this.opts = {
            selector: '.js-slider'
        };
        Object.assign(this.opts, opts);
        this.root = $(this.opts.selector);
        if (!this.root.length) return [];
        this.wrap = $('.js-slider-wrap', this.root);
        this.slides = $('.js-slider-item', this.root);
        this.pager = $('.js-slider-pager', this.root);
        this.next = $('.js-slider-next', this.root);
        this.prev = $('.js-slider-prev', this.root);
        this.current = this.slides.filter('._active').length ? this.slides.filter('._active') : this.slides.eq(0).addClass('_active');
        this.animating = false;
        this.duration = 800;

        this.init();
        this.bind();
    }

    init() {
        this.root.addClass('_dir-prev');
        this.current.next().addClass('_next');
        this.slides.last().addClass('_prev');

        this.slides.each((i,el) => {
            this.pager.append('<i' + (i == this.current.index() ? ' class="_active"' : '') + '>');
        });

        if (device.mobile() || device.tablet()) {
            this.root.hammer().on('swipeleft', (ev) => {
                //console.log('swipeleft');
                this.next.click();
            });

            this.root.hammer().on('swiperight', (ev) => {
                //console.log('swiperight');
                this.prev.click();
            });
        }
    }

    bind() {
        this.next.on('click', (e) => {
            this.slideTo(this.current.next().length ? this.current.next() : this.slides.eq(0));
        });

        this.prev.on('click', (e) => {
            this.slideTo(this.current.prev().length ? this.current.prev() : this.slides.eq(this.slides.length - 1));
        });

        this.pager.find('i').on('click', (e) => {
            this.slideTo(this.slides.eq($(e.currentTarget).index()));
        });
    }

    updateDirection(slide) {
        this.root.removeClass('_dir-prev _dir-next');
        if(this.current.index() - slide.index() == (this.slides.length - 1) || (this.current.index() - slide.index() != -(this.slides.length - 1) && this.current.index() < slide.index())) {
            this.root.addClass('_dir-next');
        } else {
            this.root.addClass('_dir-prev');
        }
    }

    updatePager() {
        this.pager.find('i').removeClass('_active').eq(this.current.index()).addClass('_active');
    }

    slideTo(slide) {
        if (this.animating || this.current[0] == slide[0]) return;
        this.animating = true;
        this.updateDirection(slide);
        this.slideFunc(slide);
        // this.slides.removeClass('_next _prev');
        // this.root[0].offsetHeight; // задержка
        // this.current.removeClass('_active').addClass('_prev');
        // this.current = slide.addClass('_active');
        this.updatePager();
        setTimeout(() => {
            this.animating = false;
            this.updatePager();
        }, this.duration);
    }

    slideFunc(slide) {
        this.slides.removeClass('_next _prev');
        this.root[0].offsetHeight; // задержка
        this.current.removeClass('_active').addClass('_prev');
        this.current = slide.addClass('_active');
    }
}
